import CustomerDetail from './CustomerDetail';

export default CustomerDetail;
